import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () => ({ breakpoints }: Theme) =>
  createStyles({
    sessionHistoryContainer: {
      width: '50%',
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
    cardHeader: {
      justifyContent: 'flex-end',
      marginBottom: 8,
    },
    graphTitle: {
      fontSize: 12,
      fontWeight: 'bold',
    },
    graphLegendsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    graphLegendItem: {
      fontSize: 12,
      alignItems: 'center ',
      display: 'flex',
      marginRight: 15,
    },
    graphSessions: {
      marginRight: 2,
      fontSize: 12,
      color: palette.yellow,
    },
    graphVacancies: {
      marginRight: 2,
      fontSize: 12,
      color: palette.digitalBlue,
    },
    graphSessionsMax: { marginRight: 2, fontSize: 20, color: palette.yellow },
    graphVacanciesMax: {
      marginRight: 2,
      fontSize: 20,
      color: palette.digitalBlue,
    },

    modalGraph: { width: 1100, justifyContent: 'center' },
    legend: { justifyContent: 'end', margin: '20px 0px', alignItems: 'end' },
    filterDate: {
      justifyContent: 'center',
      margin: '20px 0px',
      alignItems: 'end',
      display: 'inline',
    },
    filterSelector: {
      '& .MuiOutlinedInput-root': { width: '95%' },
    },
    filterSelectorPeriod: {
      marginRight: 15,
      '& .MuiOutlinedInput-root': { width: '95%' },
    },
    labelsModal: { display: 'flex' },
    closeIcon: { color: palette.error.main },
    applyButton: { borderColor: palette.blue, color: palette.blue },
    detailsButton: {
      borderColor: palette.navCompanyContextActions,
      color: palette.navCompanyContextActions,
      marginBottom: 15,
    },
  });

export const overrideModalGraph = {
  content: {
    padding: '16px 20px',
    maxHeight: 470,
    overflowX: 'auto',
    width: 1100,
  },
};

export const overrideFilter = {
  text: {
    fontWeight: 500,
    fontSize: 14,
  },
  listItem: { '& .MuiTypography-body1': { fontSize: 14 } },
};
